import React from "react";
import TransactionsPage from "components/common/transactions/TransactionsPage";

const Transactions: React.FC = () => <TransactionsPage />;

export default Transactions;
